export default "__VITE_ASSET__cc5548fd__"